module.exports = __webpack_public_path__ + "img/feature_buy_ph.312939c0.png";